import { flatten, without } from 'ramda';
import * as React from 'react';

import { FDealType, FOfferType, isAvailableOfferTypeCombination } from '../../../../../JsonQuery';
import { getOfferTypeLabel } from '../../../utils/offerType';
import { Select, Option } from '../../Select';
import { CommercialLink } from './components/CommercialLink';
import { getOfferTypeList } from './helpers';

interface IOfferTypeProps {
  open?: boolean;
  dealType: FDealType;
  value: FOfferType;
  commercialLink: string;
  offersCount: number | undefined;
  offersCountLoading?: boolean;
  openTooltip?: boolean;
  onChange(value: FOfferType): void;
  onApply?(): void;
  onOpen?(): void;
  onClose?(): void;
}

export const OfferType: React.FC<IOfferTypeProps> = ({
  open,
  dealType,
  value,
  commercialLink,
  offersCount,
  offersCountLoading,
  openTooltip,
  onChange,
  onApply,
  onOpen,
  onClose,
}) => {
  const offerTypes = getOfferTypeList(dealType);
  const offerTypeLabel = getOfferTypeLabel(dealType, value);

  const selectedOptions = flatten(offerTypes)
    .filter(offerType => (value & offerType.value) !== 0)
    .map(offerType => offerType.value);

  return (
    <Select
      open={open}
      multiple
      withoutArrow
      label={offerTypeLabel || undefined}
      placeholder="Тип предложения"
      value={selectedOptions}
      offersCount={offersCount}
      offersCountLoading={offersCountLoading}
      openTooltip={openTooltip}
      onChange={(_, selectedValues: FOfferType[]) => {
        const selectedOfferType = without(
          selectedOptions.length < selectedValues.length ? selectedOptions : selectedValues,
          selectedOptions.length < selectedValues.length ? selectedValues : selectedOptions,
        )[0];

        let nextOfferTypes: FOfferType[] = [selectedOfferType];
        if (selectedOptions.includes(selectedOfferType)) {
          if (selectedOptions.length > 1) {
            nextOfferTypes = selectedOptions.filter(o => o !== selectedOfferType);
          }
        } else {
          if (
            isAvailableOfferTypeCombination(
              [...selectedOptions, selectedOfferType].reduce(
                (previousValue, currentValue) => previousValue | currentValue,
                FOfferType.Unexpected,
              ),
            )
          ) {
            nextOfferTypes = [...selectedOptions, selectedOfferType];
          }
        }

        const nextOfferType: FOfferType = nextOfferTypes.reduce(
          (previousValue, currentValue) => previousValue | currentValue,
          FOfferType.Unexpected,
        );

        onChange(nextOfferType);
      }}
      onApply={onApply}
      onOpen={onOpen}
      onClose={onClose}
      popupPostfix={dealType !== FDealType.RentDaily ? <CommercialLink href={commercialLink} /> : null}
    >
      {offerTypes.map(parts =>
        parts.map(offerType => (
          <Option key={`${offerType.label}_${offerType.value}`} value={offerType.value} marker={offerType.marker}>
            {offerType.label}
          </Option>
        )),
      )}
    </Select>
  );
};
